
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { QueryClient, QueryClientProvider } from 'react-query'
import { PopupCloseContextProvider } from './shared/contexts/popupclose-context'
import { MsalProvider } from '@azure/msal-react'
import { PublicClientApplication } from '@azure/msal-browser'
import { msalConfig } from './authConfig'

const queryClient = new QueryClient()
const msalInstance = new PublicClientApplication(msalConfig)

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

root.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <QueryClientProvider client={queryClient}>
        <PopupCloseContextProvider>
          <App />
        </PopupCloseContextProvider>
      </QueryClientProvider>
    </MsalProvider>
  </React.StrictMode>
)

reportWebVitals()

